require('./build/scripts/ng-map.js');
module.exports = 'ngMap';


//////////////////
// WEBPACK FOOTER
// ./~/ngmap/index.js
// module id = 279
// module chunks = 0